import apiService from './api.service';

class BannerService {
  async getBannerImage() {
    try {
      const response = await apiService.post('/sections/get-by-uid', {
        UID: 'HOME-BANNER'
      }, {}, true);

      if (response && response.code === 1 && response.data) {
        const bannerData = Array.isArray(response.data) ? response.data[0] : response.data;
        return this.transformBannerData(bannerData);
      }

      return null;
    } catch (error) {
      return null;
    }
  }

  transformBannerData(apiData) {
    if (!apiData) return null;

    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    let imageUrl = apiData.ImageUrl || apiData.imageUrl || apiData.Link || apiData.image;
    if (imageUrl && !imageUrl.startsWith('http')) {
      imageUrl = `${baseUrl}${imageUrl.startsWith('/') ? '' : '/'}${imageUrl}`;
    }

    return {
      imageUrl: imageUrl
    };
  }
}

export default new BannerService();
